import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { ArchiveTagMutation, ArchiveTagMutationVariables } from '@/gql/graphql';

const ArchiveTag = graphql(`
  mutation ArchiveTag($input: ArchiveTagInput!) {
    archiveTag(input: $input) {
      id
    }
  }
`);

const useArchiveTag = (
  options?: UseMutationOptions<
    ArchiveTagMutation,
    unknown,
    ArchiveTagMutationVariables['input']
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(ArchiveTag, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountAvailableTags(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useArchiveTag;
